import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IBlogArticlesListProps } from '../components/blog/blog-articles-list/blog-articles-list';
import { Models } from './index';

export class BlogArticlesListModel extends ContentItem {
  get title(): string {
    return get(this._config, 'elements.title_value.value', '');
  }

  get subtitle(): string {
    return get(this._config, 'elements.subtitle.value', '');
  }

  get buttonText(): string {
    return get(this._config, 'elements.button_text.value', '');
  }

  get articles(): [] {
    const nodes = get(this._config, 'notFeatured', []);
    const modeledArticles = nodes.map((article: IBlogArticle) =>
      Models.BlogArticleModel.create(article as IBlogArticle)
    );
    return modeledArticles;
  }

  public static create(data: IBlogArticlesList): IBlogArticlesListProps {
    const { title, subtitle, buttonText, articles } = new BlogArticlesListModel(
      data
    );

    return {
      title,
      subtitle,
      buttonText,
      articles
    };
  }
}
